import React from 'react';
import { contactsApi, quotesApi, itemsApi } from '@/core/adapter-api';
import { v4 as uuidv4 } from 'uuid';
import { BuildProComponent } from '../modules/buildpro';
import type { DBAdapter } from '../modules/buildpro';
import { useToast } from './shared';

export const PresupuestosIAPage: React.FC = () => {
  const { addToast } = useToast();
  const dbAdapter: DBAdapter = {
    async saveQuote(quote) {
      let aiClient = (await contactsApi.all()).find(c => c.name === 'BuildPro AI');
      let clientId = aiClient?.id;
      if (!clientId) {
        clientId = await contactsApi.add({
          type: 'client',
          name: 'BuildPro AI',
          nif: 'AI-GEN',
          email: 'ai@buildpro.app',
          phone: '',
          address: 'Virtual Plan',
          city: '', zip: '', province: '', country: '', notes: 'Generados automáticamente',
          createdAt: Date.now(), updatedAt: Date.now()
        } as any);
      }

      const lines = quote.items.map(item => ({
        id: uuidv4(),
        title: item.name,
        description: 'Auto-generado por IA (BuildPro)',
        quantity: item.quantity,
        unit: item.unit,
        price: item.price,
        vatPct: 21,
        discountPct: 0,
        retentionPct: 0
      }));

      const dateStr = new Date().toISOString();
      const quoteId = await quotesApi.add({
        number: `AI-${Date.now().toString().slice(-6)}`,
        date: dateStr,
        dueDate: dateStr,
        contactId: clientId!,
        status: 'draft',
        lines,
        notes: quote.resumen + '\n\n' + 'Confianza: ' + quote.confianza,
        baseTotal: quote.totalExVat,
        vatTotal: quote.vat21,
        retentionTotal: 0,
        grandTotal: quote.totalIncVat,
        createdAt: Date.now(),
        updatedAt: Date.now(),
      } as any);

      return quoteId;
    },
    
    async upsertItems(items) {
      for (const item of items) {
        try {
          const existing = await itemsApi.get(item.id);
          const data = {
            sku: item.cod,
            name: item.name,
            description: item.name,
            category: item.category,
            price: item.price,
            vatPct: 21,
            unit: item.unit,
            type: 'service',
            active: true,
            updatedAt: Date.now()
          } as any;
          
          if (existing) {
            await itemsApi.update(item.id, data);
          } else {
            await itemsApi.add({ id: item.id, ...data, createdAt: Date.now() });
          }
        } catch {
          // Item upsert failed silently
        }
      }
    },
    
    async getQuotes() {
      return [];
    }
  };

  return (
    <div className="-mx-4 md:-mx-8 -my-4 md:-my-8 relative min-h-[calc(100vh-80px)] md:min-h-screen bg-gray-950">
      <BuildProComponent 
        dbAdapter={dbAdapter} 
        onQuoteSaved={(id) => {
          addToast('Presupuesto IA guardado correctamente (ID: ' + id + ')', 'success');
        }}
      />
    </div>
  );
};
